type SiteElementImageSizes = "thumb" | "normal" | "zoom";
interface ISiteElementImageSize {
    size: SiteElementImageSizes;
    src: string;
}
interface ISiteElementImageSizes {
    sizes: ISiteElementImageSize[];
}

class SiteElementImageFull
    extends QueryElement<HTMLElement> {

    private _info: ISiteElementImageSizes;
    private _parent: SiteElementImage;
    private _image: QueryElement<HTMLElement>;
    private _zoom: QueryElement<HTMLElement>;
    private _zoomWidth: number;
    private _zoomHeight: number;
    
    constructor(parent: SiteElementImage, info: ISiteElementImageSizes) {
        super(document.createElement("DIV"));

        this._parent = parent;
        this._info = info;

        this.addClass("container");
        
        var src = this._info.sizes.filter(a => a.size == "normal")[0].src;
        var srcZoom = this._info.sizes.filter(a => a.size == "zoom")[0].src;
        this._image = QueryElement.QueryElement("IMG")
            .setAttr("src", src)
            .appendTo(this);

        // Add magnify glass
        if (this._parent.getConfig().zoomFull == false) {
            this._zoom = QueryElement.QueryElement("DIV")
                .addClass("zoom")
                .appendTo(this);
        } else {
            this._zoom = QueryElement.QueryElement("DIV")
                .addClass("zoom-full")
                .appendTo(this);
        }

        var style = this._zoom.style();
        var config = this._parent.getConfig();
        if (style == null)
            throw "Couldn't get style";

        this._zoomWidth = config.zoomSize.width / 2;
        this._zoomHeight = config.zoomSize.height / 2;
        
        style.backgroundImage = `url(${srcZoom})`;
        style.backgroundRepeat = "no-repeat";
        style.width = `${config.sizes.normal.width * config.zoom}px`;
        style.height = `${config.sizes.normal.height * config.zoom}px`;

        if (!Site.isMobile())
        {
            this.on("pointermove", (e: PointerEvent) => { this.onMove(e) });
            this.on("pointerenter", () => { this.show() });
            this.on("pointerleave", () => { this.hide() });
        }
    }
    
    show() {
        this._zoom.addClass("visible");
    }
    hide() {
        this._zoom.removeClass("visible");
    }

    onMove(e: PointerEvent) {
        var config = this._parent.getConfig();
        var style = this._zoom.style();
        var dimensions = this._image.position();
        if (dimensions == null || style == null)
            throw "Couldn't get style/position";

        var position = this.getCursorPosition(e);
        var x = position.x;
        var y = position.y;

        if (this._parent.getConfig().zoomFull == false) {
            var offsetLeft = (dimensions.width - config.sizes.normal.width) / 2;
            var offsetTop = (dimensions.height - config.sizes.normal.height) / 2;

            if (x > (config.sizes.normal.width + offsetLeft) - (this._zoomWidth / config.zoom))
                x = (config.sizes.normal.width + offsetLeft) - (this._zoomWidth / config.zoom);
            if (x < (this._zoomWidth / config.zoom) + offsetLeft)
                x = (this._zoomWidth / config.zoom) + offsetLeft;
            if (y > (config.sizes.normal.height + offsetTop) - (this._zoomHeight / config.zoom))
                y = (config.sizes.normal.height + offsetTop) - (this._zoomHeight / config.zoom);
            if (y < (this._zoomHeight / config.zoom) + offsetTop)
                y = (this._zoomHeight / config.zoom) + offsetTop;


            style.left = `${x - this._zoomWidth}px`;
            style.top = `${y - this._zoomHeight}px`;

            style.backgroundPosition = `${(((x - offsetLeft) * config.zoom) - this._zoomWidth) * -1}px ${(((y - offsetTop) * config.zoom) - this._zoomHeight) * -1}px`;
        } else {
            var extraWidth = (this.get()?.clientWidth || config.sizes.normal.width) - config.sizes.normal.width;
            x-= (extraWidth / (config.zoom)) * (config.zoom - 1);
            style.backgroundPosition = `${(x * (config.zoom - 1)) * -1}px ${(y * (config.zoom - 1)) * -1}px`;
        }
        
    }

    getCursorPosition(e: PointerEvent) {
        var x = 0, y = 0;
        /* Get the x and y positions of the image: */
        var config = this._parent.getConfig();
        var position = this._image.position();
        if (position == null)
            throw "Couldn't get position";
        
        /* Calculate the cursor's x and y coordinates, relative to the image: */
        x = e.clientX - position.left;
        y = e.clientY - position.top;

        return {x : x, y : y};
    }
}

class SiteElementImageThumb
    extends QueryElement<HTMLElement> {
    
    private _info: ISiteElementImageSizes;
    private _parent: SiteElementImage;

    constructor(parent: SiteElementImage, info: ISiteElementImageSizes) {
        super(document.createElement("IMG"));

        this._parent = parent;
        this._info = info;

        this.on("click", () => {
            var current = this._parent.getActive();
            if (current != null)
                current.makeInactive();
            
            this.makeActive();
        });

        this.setAttr("src", this._info.sizes.filter(a => a.size == "thumb")[0].src);
    }

    makeActive() {
        this._parent.setFull(this._info);
        this.addClass("active");
        this.get()?.scrollIntoView(false);
    }
    makeInactive() {
        this.removeClass("active");
    }
}

class SiteElementImage
    extends QueryElement<HTMLElement> {

    private _images : ISiteElementImageSizes[] = [];
    private _config = {
        zoom: 3,
        zoomFull: true,
        zoomSize: {
            width: 100,
            height: 100
        },
        sizes: {
            thumb: {
                width: 100,
                height: 100
            },
            normal: {
                width: 500,
                height: 500
            },
            zoom: {
                width: 1000,
                height: 1000
            }
        }
    }
    _container_full: QueryElement<HTMLElement>;
    _container_thumb: QueryElement<HTMLElement>;
    _container_image: QueryElement<HTMLElement>;
    _container_zoom: QueryElement<HTMLElement>;
    
    constructor(element: HTMLElement) {
        super(element);

        var pictures = this.query("picture").all(a => a);
        for(let picture of pictures) {

            var image : ISiteElementImageSizes = {
                sizes: []
            };

            for (let child of picture.children()) {
                image.sizes.push({
                    size: child.getAttr("data-width") as SiteElementImageSizes,
                    src: child.getAttr("srcset") || ""
                });
            }

            this._images.push(image);
        }

        this._container_full = QueryElement.QueryElement("div").addClass("full");
        this._container_zoom = QueryElement.QueryElement("div").addClass("zoom");
        this._container_thumb = QueryElement.QueryElement("div").addClass("thumb");

        // -- Create image content
        this._container_image = QueryElement.QueryElement("div")
            .addClass("image")
            .appendTo(this._container_full);
        QueryElement.QueryElement("div")
            .addClass("left")
            .setHtml("<i>keyboard_arrow_left</i>")
            .appendTo(this._container_full)
            .on("click", () => this.prevActive());
        QueryElement.QueryElement("div")
            .addClass("right")
            .setHtml("<i>keyboard_arrow_right</i>")
            .appendTo(this._container_full)
            .on("click", () => this.nextActive());
        
        // -- Add thumbs
        for (let image of this._images) {
            new SiteElementImageThumb(this, image)
                .appendTo(this._container_thumb);
        }
        
        
        // Add both containers to this object
        this.append(this._container_full)
            .append(this._container_thumb);
        
        
        // Make first active
        this._container_thumb
            .firstChild<SiteElementImageThumb>()
            ?.makeActive();
    }

    setFull(image: ISiteElementImageSizes) {
        this._container_image.clear();
        this._container_image.append(
            new SiteElementImageFull(this, image)
        );
    }

    getActive() {
        return this._container_thumb.query(".active").first<SiteElementImageThumb>();
    }
    nextActive() {
        var active = this.getActive();
        if (active != null) {
            active.makeInactive();
            var nextItem = active.next<SiteElementImageThumb>();
            if (nextItem != null)
                nextItem.makeActive();
            else
                this._container_thumb.firstChild<SiteElementImageThumb>()?.makeActive();
        }
    }
    prevActive() {
        var active = this.getActive();
        if (active != null) {
            active.makeInactive();
            var nextItem = active.prev<SiteElementImageThumb>();
            if (nextItem != null)
                nextItem.makeActive();
            else
                this._container_thumb.lastChild<SiteElementImageThumb>()?.makeActive();
        }
    }
    getZoom() {
        return this._container_zoom;
    }
    getConfig() {
        return this._config;
    }
}